const OrgStructureItemsTableColumns = [
    { id: 'display_order', labelAr: 'الترتيب', labelEn: 'Order', width: 80 },
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 90 },
    { id: 'name', labelAr: 'اسم العنصر', labelEn: 'Item Name' },
    { id: 'parent_name', labelAr: 'العنصر الأب', labelEn: 'Parent', width: 160 },
    { id: 'allows_multiple', labelAr: 'يسمح بتعدد', labelEn: 'Multi', width: 90 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 100 },
];

export default OrgStructureItemsTableColumns;
